module.exports = __webpack_public_path__ + "static/media/icon_4.3f1b86a3.png";